<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready">
            <div class="card mb-3">
                <div class="card-title" v-once>
                    <span v-if="editing">Филиал – {{ entry.name }}</span>
                    <span v-else>Создать филиал</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <text-field
                            class="w-1/2 px-2"
                            title="Название"
                            v-model="entry.name"
                            :errors="errors.name"
                            required
                        />

                        <text-field
                            class="w-1/2 px-2"
                            title="Адрес"
                            v-model="entry.address"
                            :errors="errors.address"
                            required
                        />
                    </div>

                    <hr class="mb-3" />

                    <button class="btn btn-primary">Сохранить</button>

                    <button v-if="editing" @click.prevent="destroy" class="btn btn-danger">Удалить</button>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";

export default {
    extends: ResourceForm,

    data() {
        return {
            resource: {
                name: "admin.branches",
                endpoint: "admin/branches"
            }
        };
    },

    methods: {},

    mounted() {}
};
</script>